// extracted by mini-css-extract-plugin
export default {"sideMenu":"transition_sideMenu__Usu6B","navigateText":"transition_navigateText__LSD1O","conditionedCover":"transition_conditionedCover__2R02g"};